import { Platforms as Structures } from '@/components/Platforms';
import { Platforms } from '@/components/Structures/Platforms';
import { PageLoader } from '@/components/shared/PageLoader';
import { useFetchCookies } from '@/hooks';
import { useAuthService } from '@/hooks/useAuthService';
import { DefaultLayout } from '@/layouts/DefaultLayout';
import { Box } from '@mui/material';

export const HomePage = () => {
  const cookiesFetched = useFetchCookies();
  const { isLoggingOut } = useAuthService();

  if (!cookiesFetched || isLoggingOut) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout>
      {import.meta.env.VITE_APP_ENABLE_PLATFORMS ? <Platforms /> : <Structures />}
    </DefaultLayout>
  );
};
